// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-modules-TickedCopy-style----general-module---container---BlwRC fill-marvel display-flex","tick":"src-components-modules-TickedCopy-style----general-module---tick---3w7yM marginRight-xs lineHeight-s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/TickedCopy/style/general.module.css
// module id = 1493
// module chunks = 168707334958949